// Shared helpers for the public blog (list + article pages).

export interface BlogPostPreview {
    heading: string;
    image: string;
    url: string;
    description: string;
    timeStamp: string;
}

export interface BlogPostDetail extends Omit<BlogPostPreview, "url"> {
    text: string;
    author?: string;
    keyWords?: string;
    posts: BlogPostPreview[];
}

const MONTHS = [
    "ledna", "února", "března", "dubna", "května", "června",
    "července", "srpna", "září", "října", "listopadu", "prosince",
];

// "5. června 2026" — Czech long form, matches the site's premium tone.
export function czechDate(input: string | number | Date): string {
    const d = new Date(input);
    return `${d.getDate()}. ${MONTHS[d.getMonth()]} ${d.getFullYear()}`;
}

// Rough read estimate at ~200 words/min, never below 1.
export function readingTime(text: string): number {
    const words = text ? text.trim().split(/\s+/).filter(Boolean).length : 0;
    return Math.max(1, Math.round(words / 200));
}

// Trim a description to a card-friendly length on a word boundary.
export function excerpt(text: string, max = 160): string {
    if (!text) return "";
    if (text.length <= max) return text;
    const cut = text.slice(0, max);
    const lastSpace = cut.lastIndexOf(" ");
    return (lastSpace > 0 ? cut.slice(0, lastSpace) : cut).trimEnd() + "…";
}
